import React from "react";
import {
  Card as MuiCard,
  CardHeader as MuiCardHeader,
  CardContent as MuiCardContent,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardBase: {
    height: "100%",
    border: `1px solid ${theme.palette.divider}`,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    // borderRadius: 8,
    overflow: "hidden",
  },
  hoverable: {
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.06)",
      borderColor: theme.palette.primary.main,
    },
  },
  static: {
    backgroundColor: "#fafafa",
    boxShadow: "none",
  },
  active: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: "#fff",
  },
  header: {
    padding: theme.spacing(1.5, 2, 0, 2),
  },
  headerAction: {
    margin: 0,
  },
  content: {
    padding: theme.spacing(2),
    "&:last-child": {
      paddingBottom: theme.spacing(2),
    },
  },
  title: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.02em",
  },
}));

export const SKCard = ({ variant = "static", active = false, children, className = "", ...props }) => {
  const classes = useStyles();

  const cardClasses = [
    classes.cardBase,
    variant === "hoverable" && classes.hoverable,
    variant === "static" && classes.static,
    active && classes.active,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <MuiCard className={cardClasses} elevation={0} {...props}>
      {children}
    </MuiCard>
  );
};

export const SKCardHeader = ({ title, className = "", ...props }) => {
  const classes = useStyles();

  return (
    <MuiCardHeader
      title={title}
      className={`${classes.header} ${className}`}
      classes={{
        action: classes.headerAction,
        title: classes.title,
      }}
      {...props}
    />
  );
};

export const SKCardContent = ({ children, className = "", ...props }) => {
  const classes = useStyles();

  return (
    <MuiCardContent className={`${classes.content} ${className}`} {...props}>
      {children}
    </MuiCardContent>
  );
};
